import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaFilePdf } from 'react-icons/fa';

const MeuVisagismoClienteDetalhesModal = ({ cliente, usuario, onClose }) => {
    const [clienteDetalhes, setClienteDetalhes] = useState(null);

    useEffect(() => {
        fetchClienteDetalhes();
    }, [usuario, cliente]);

    const fetchClienteDetalhes = async () => {
        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {            
            const response = await api.get(`/meu-visagismo/usuario/${usuario.usuario_uuid}/cliente/${cliente.id}`);
            setClienteDetalhes(response.data.cliente);
            Swal.close();
        } catch (error) {
            Swal.close();
        }
    };

    const abrirPDF = (pdfBase64) => {
        if (pdfBase64) {
            const pdfBlob = new Blob(
                [Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], 
                {type: 'application/pdf'}
            );
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }
    };
    
    const abrirImagem = (imagemBase64) => {
        if (imagemBase64) {
            const newTab = window.open();
            newTab.document.write(`
                <html>
                    <head>
                        <title>Visualização da Imagem</title>
                        <style>
                            body { 
                                margin: 0; 
                                padding: 0; 
                                display: flex; 
                                justify-content: center; 
                                align-items: center; 
                                min-height: 100vh; 
                                background-color: #1e1e1e;
                            }
                            img { 
                                max-width: 100%; 
                                max-height: 95vh; 
                                object-fit: contain;
                            }
                        </style>
                    </head>
                    <body>
                        <img src="data:image/jpeg;base64,${imagemBase64}" />
                    </body>
                </html>
            `);
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Cliente</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        {clienteDetalhes ? (
                            <>
                                <div className="row mt-3">
                                    
                                    <div className="col-lg-6 col-12">
                                        <div className="card h-100">
                                            <h5 className="fw-bold ms-3 mt-3 mb-3">Respostas do Formulário</h5>
                                            <div className="card-body" style={{height: '530px', overflowY: 'auto'}}>
                                                
                                                <div className="">
                                                    
                                                    {clienteDetalhes.email && (
                                                        <div className="mb-3">
                                                            <div className="text-muted">E-mail</div>
                                                            <div className="fw-bold">{clienteDetalhes.email}</div>
                                                        </div>
                                                    )}
                                                    
                                                    {clienteDetalhes.cpf && (
                                                        <div className="mt-3 border-top pt-3 mb-3">
                                                            <div className="text-muted">CPF</div>
                                                            <div className="fw-bold">{clienteDetalhes.cpf}</div>
                                                        </div>
                                                    )}

                                                    {clienteDetalhes.form_data?.questions[0]?.map((item, index) => (
                                                        <div key={index} className="mt-3 border-top pt-3 mb-3">
                                                            <div className="text-muted mt-1">{item.question}</div>
                                                            <div className="fw-bold">
                                                                {Array.isArray(item.answer) 
                                                                    ? item.answer.join(", ") 
                                                                    : item.answer}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                
                                                <div className="mt-4 pt-3 border-top">
                                                    <h6 className="fw-bold mb-3">Endereço</h6>
                                                    
                                                    {clienteDetalhes.rua && clienteDetalhes.numero && (
                                                        <div className="mb-2">
                                                            <div className="text-muted">Logradouro</div>
                                                            <div className="fw-bold">
                                                                {clienteDetalhes.rua}, {clienteDetalhes.numero}
                                                                {clienteDetalhes.complemento && ` - ${clienteDetalhes.complemento}`}
                                                            </div>
                                                        </div>
                                                    )}
                                                    
                                                    {clienteDetalhes.bairro && (
                                                        <div className="mb-2">
                                                            <div className="text-muted">Bairro</div>
                                                            <div className="fw-bold">{clienteDetalhes.bairro}</div>
                                                        </div>
                                                    )}
                                                    
                                                    {clienteDetalhes.cidade && clienteDetalhes.estado && (
                                                        <div className="mb-2">
                                                            <div className="text-muted">Cidade/Estado</div>
                                                            <div className="fw-bold">{clienteDetalhes.cidade} - {clienteDetalhes.estado}</div>
                                                        </div>
                                                    )}
                                                    
                                                    {clienteDetalhes.cep && (
                                                        <div className="mb-2">
                                                            <div className="text-muted">CEP</div>
                                                            <div className="fw-bold">{clienteDetalhes.cep}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                        <div>
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <h5 className="fw-bold mb-3">Fotos do Cliente</h5>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3 mb-md-0 text-center">
                                                            {clienteDetalhes.user_image_front ? (
                                                                <div className="position-relative">
                                                                    <img 
                                                                        src={`data:image/jpeg;base64,${clienteDetalhes.user_image_front}`} 
                                                                        alt="Foto Frontal" 
                                                                        className="img-fluid rounded shadow-sm" 
                                                                        style={{
                                                                            maxHeight: '160px', 
                                                                            width: '100%',
                                                                            objectFit: 'cover', 
                                                                            cursor: 'pointer',
                                                                            transition: 'opacity 0.3s ease'
                                                                        }}
                                                                        onClick={() => abrirImagem(clienteDetalhes.user_image_front)}
                                                                        onMouseOver={(e) => e.target.style.opacity = '0.8'}
                                                                        onMouseOut={(e) => e.target.style.opacity = '1'}
                                                                    />
                                                                    <div className="position-absolute bottom-0 w-100 bg-dark bg-opacity-75 text-white p-1">
                                                                        <small>Frontal</small>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="border rounded p-4 text-muted bg-light">
                                                                    <p>Sem foto frontal</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        
                                                        <div className="col-md-4 mb-3 mb-md-0 text-center">
                                                            {clienteDetalhes.user_image_profile ? (
                                                                <div className="position-relative">
                                                                    <img 
                                                                        src={`data:image/jpeg;base64,${clienteDetalhes.user_image_profile}`} 
                                                                        alt="Foto de Perfil" 
                                                                        className="img-fluid rounded shadow-sm" 
                                                                        style={{
                                                                            maxHeight: '160px', 
                                                                            width: '100%',
                                                                            objectFit: 'cover', 
                                                                            cursor: 'pointer',
                                                                            transition: 'opacity 0.3s ease'
                                                                        }}
                                                                        onClick={() => abrirImagem(clienteDetalhes.user_image_profile)}
                                                                        onMouseOver={(e) => e.target.style.opacity = '0.8'}
                                                                        onMouseOut={(e) => e.target.style.opacity = '1'}
                                                                    />
                                                                    <div className="position-absolute bottom-0 w-100 bg-dark bg-opacity-75 text-white p-1">
                                                                        <small>Perfil</small>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="border rounded p-4 text-muted bg-light">
                                                                    <p>Sem foto de perfil</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        
                                                        <div className="col-md-4 text-center">
                                                            {clienteDetalhes.user_image_back ? (
                                                                <div className="position-relative">
                                                                    <img 
                                                                        src={`data:image/jpeg;base64,${clienteDetalhes.user_image_back}`} 
                                                                        alt="Foto de Costas" 
                                                                        className="img-fluid rounded shadow-sm" 
                                                                        style={{
                                                                            maxHeight: '160px', 
                                                                            width: '100%',
                                                                            objectFit: 'cover', 
                                                                            cursor: 'pointer',
                                                                            transition: 'opacity 0.3s ease'
                                                                        }}
                                                                        onClick={() => abrirImagem(clienteDetalhes.user_image_back)}
                                                                        onMouseOver={(e) => e.target.style.opacity = '0.8'}
                                                                        onMouseOut={(e) => e.target.style.opacity = '1'}
                                                                    />
                                                                    <div className="position-absolute bottom-0 w-100 bg-dark bg-opacity-75 text-white p-1">
                                                                        <small>Costas</small>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="border rounded p-4 text-muted bg-light">
                                                                    <p>Sem foto de costas</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h5 className="fw-bold mb-0">Imagens Geradas</h5>
                                                        {clienteDetalhes.pdf ? (
                                                            <button 
                                                                className="btn btn-custom-primary" 
                                                                onClick={() => abrirPDF(clienteDetalhes.pdf)}
                                                            >
                                                                <FaFilePdf className="me-1" /> Ver PDF
                                                            </button>
                                                        ) : (
                                                            <span className="badge p-2 bg-secondary" style={{fontSize: '14px'}}>PDF Não Gerado</span>
                                                        )}
                                                    </div>
                                                    <div className="row">
                                                        {[
                                                            { key: 'image1', label: 'Sugestão 1' },
                                                            { key: 'image2', label: 'Sugestão 2' },
                                                            { key: 'image3', label: 'Sugestão 3' },
                                                            { key: 'image4', label: 'Sugestão 4' }
                                                        ].map((image, index) => (
                                                            <div className="col-lg-6 col-12 mt-3" key={index}>
                                                                {clienteDetalhes[image.key] ? (
                                                                    <div className="text-center position-relative h-100">
                                                                        <img 
                                                                            src={`data:image/jpeg;base64,${clienteDetalhes[image.key]}`} 
                                                                            alt={image.label} 
                                                                            className="img-fluid rounded shadow-sm" 
                                                                            style={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'cover',
                                                                                cursor: 'pointer',
                                                                                transition: 'opacity 0.3s ease'
                                                                            }}
                                                                            onClick={() => abrirImagem(clienteDetalhes[image.key])}
                                                                            onMouseOver={(e) => e.target.style.opacity = '0.8'}
                                                                            onMouseOut={(e) => e.target.style.opacity = '1'}
                                                                        />
                                                                        <div className="position-absolute bottom-0 w-100 bg-dark bg-opacity-75 text-white p-1">
                                                                            <small>{image.label}</small>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="border rounded py-5 text-center text-muted bg-light h-100" style={{minHeight: '200px'}}>
                                                                        <p className="mb-0 small">Imagem não disponível</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="text-center p-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                                <p className="mt-3">Carregando detalhes do cliente...</p>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeuVisagismoClienteDetalhesModal;
